import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { vehicleGroupSchema } from '../schemas/vehicle-group.schema';

/**
 * Requests the Vehicle Groups associated with a specific Vehicle
 * @param vehicleGroupId The ID of the Vehicle whose Vehicle Groups are being requested
 * @returns The Vehicle Groups
 */
export function getVehiclesIdGroups(this: unknown, vehicleId: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment.resolve(this).vehiclesIdGroupsUrl(vehicleId),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(vehicleGroupSchema),
      })
    )
  );
}
